import { useModelContext } from '@app/contexts/model';
import { useStorageContext } from '@app/contexts/storage';
import { MAIN_PAGE } from '@app/enums';
import { columnDefs } from '@app/modules/ConfirmTranslate/factory/columnDefs';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { MLanguageFilesAccepted } from '@elte/translate-backend/interface/lang_files_accepted';
import { GridOptions, GridReadyEvent, RowDoubleClickedEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { observe } from 'mobx';
import React, { FunctionComponent, useEffect } from 'react';
import { useStorageConfirmTranslateContext } from '../../contexts/storage';
import './Table.scss';

export const Table: FunctionComponent = () => {
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();
    const { langFilesAcceptedModel } = useModelContext();
    const { translateStore } = useStorageTranslateContext();
    const { globalStorage } = useStorageContext();
    // let observe: Lambda = () => null;

    const gridOptions: GridOptions<MLanguageFilesAccepted.TResponseFind> = {
        columnDefs: columnDefs(),
        getRowId(data) {
            return data.data.id + '_' + data.data.lang;
        },
        onGridReady(event: GridReadyEvent): void {
            confirmTranslateStore.gridApi = event.api;
            confirmTranslateStore.gridApi.sizeColumnsToFit();
            event.api.setGridOption('rowData', langFilesAcceptedModel.dataLangFilesAccepted);
        },
        rowSelection: 'single',
        suppressRowClickSelection: false,
        onSelectionChanged(event: SelectionChangedEvent): void {
            confirmTranslateStore.gridApi.getSelectedRows().forEach((item) => {
                confirmTranslateStore.acceptedUserId = item.id;
                confirmTranslateStore.userLogin = item.userName;
                confirmTranslateStore.languageToAccept = item.lang;
            });
            langFilesAcceptedModel.getSelectedToAccept(confirmTranslateStore.acceptedUserId, confirmTranslateStore.languageToAccept).then(
                (v) => {
                    // confirmTranslateStore.usersTranslationTarget.set(v.target)
                    confirmTranslateStore.fileId = v.fileId;
                },
                (reason) => console.log('error')
            );
        },
        onRowDoubleClicked(event: RowDoubleClickedEvent): void {
            langFilesAcceptedModel.getSelectedToAccept(confirmTranslateStore.acceptedUserId, confirmTranslateStore.languageToAccept).then(
                (v) => {
                    confirmTranslateStore.fileId = v.fileId;

                    if (!confirmTranslateStore.fileId && confirmTranslateStore.fileId.length === 2) {
                        translateStore.handleOpenConfirmModalError();
                    } else {
                        translateStore.mainLanguageId = '';
                        globalStorage.openModule = MAIN_PAGE.TRANSLATE;
                        confirmTranslateStore.usersTranslationTarget.set(v.target);
                    }
                },
                (reason) => console.log('error')
            );
        }
    };

    useEffect(() => {
        const removeObserve = observe(langFilesAcceptedModel.dataLangFilesAccepted, (changeData) => {
            confirmTranslateStore.gridApi.setGridOption('rowData', changeData.object);
        });

        let listener = () => confirmTranslateStore.gridApi.sizeColumnsToFit();
        window.addEventListener('resize', listener);

        return () => {
            removeObserve();
            window.removeEventListener('resize', listener);
            confirmTranslateStore.gridApi = null;
        };
    });

    return <AgGridReact className={'table_confirm table_confirm--box ag-theme-balham'} gridOptions={gridOptions as any} rowData={langFilesAcceptedModel.dataLangFilesAccepted} />;
};
